import { RESET_STATE } from 'store/global/actions';

import { APPRAISAL_PRODUCT_SCHEMA_ACTION_TYPE } from '../actions';

const initialState = {};

const appraisalProductSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case APPRAISAL_PRODUCT_SCHEMA_ACTION_TYPE.GET_APPRAISAL_PRODUCT_SCHEMA:
      return payload || state;

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default appraisalProductSchemaReducer;
